import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"
import { connect } from "react-redux"
import _split from "lodash/split"
import _find from "lodash/find"
import _isEmpty from "lodash/isEmpty"

import AudioRequestModal from "./components/AudioRequestModal"
import RequestDetailsModal from "./components/RequestDetailsModal"
import { showToast } from "../../../../components/Toast"
import Loading from "../../../../components/Loading"

import {
  getServiceRequestsCustomer,
  requestAudioProtocol
} from "services/state/actions"
import { fileType, typeOptions } from "./constants"

const AudioRequest = ({
  protocol,
  onCloseModal,
  customerEmail,
  protocolDetails,
  requestAudioProtocol,
  getServiceRequestsCustomer,
  products
}) => {
  const [step, setStep] = useState(1)
  const [requestDetails, setRequestDetails] = useState({})
  const [email, setEmail] = useState(customerEmail)
  const [isLoading, setIsLoading] = useState(false)
  const [requestProtocol, setRequestProtocol] = useState("")
  const [shippingMethod, setShippingMethod] = useState({
    type: typeOptions[0],
    format: fileType[0]
  })

  const audioRequestService = (details) => {
    const payload = {
      "cpf-cnpj": protocolDetails.data.primaryDocumentNumber,
      protocol: protocol.protocolNumber
    }

    getServiceRequestsCustomer(
      payload,
      (response) => {
        if (response.payload && response.payload.data.serviceRequests) {
          const serviceRequest = response.payload.data.serviceRequests[0]
          const assetId = serviceRequest.asset.id
          const product = _find(products, (item) => item.assetId === assetId)

          if (!_isEmpty(product)) {
            sendingRequestAudio(details, assetId)
            return
          }
          setIsLoading(false)
          showMessageError()
        }
      },
      () => {
        setIsLoading(false)
        showMessageError()
      }
    )
  }

  const sendingRequestAudio = (details, assetId) => {
    const payload = {
      customerPrimaryDocumentNumber: protocolDetails.data.primaryDocumentNumber,
      assetId,
      productLine: protocol.productType,
      requestChannel: protocolDetails.data.requestChannel,
      worklogText: protocolDetails.data.note,
      callProtocol: _split(protocol.protocolNumber, "-")[0],
      customerEmail: details.email,
      protocolDateCreated: protocolDetails.data.createdAt,
      shippingWay: "EMAIL",
      wayOfMakingAvailable: details.format === "WEB" ? "AUDIO-WEB" : "PDF",
      user: "portalclientes"
    }

    requestAudioProtocol(
      payload,
      (response) => {
        if (response.payload && response.payload.data.protocol) {
          setIsLoading(false)
          setRequestProtocol(response.payload.data.protocol)
          setRequestDetails(details)
          setStep((prevState) => prevState + 1)
        }
      },
      () => {
        setIsLoading(false)
        showMessageError()
      }
    )
  }

  const showMessageError = () => {
    showToast({
      message:
        "Ocorreu um erro na sua solicitação. Por favor, tente novamente!",
      type: "error"
    })
    handleCloseModal()
  }

  const handleNextStep = (details) => {
    setIsLoading(true)

    audioRequestService(details)
  }

  const handleCloseModal = () => {
    onCloseModal()
  }

  return (
    <Fragment>
      <Loading isOpen={isLoading} />

      <AudioRequestModal
        isOpen={step === 1}
        protocol={protocol}
        onNextStep={handleNextStep}
        onCloseModal={handleCloseModal}
        shippingMethod={shippingMethod}
        onChangeShippingMethod={setShippingMethod}
        email={email}
        setEmail={setEmail}
      />
      <RequestDetailsModal
        isOpen={step === 2}
        requestDetails={requestDetails}
        onCloseModal={handleCloseModal}
        requestProtocol={requestProtocol}
      />
    </Fragment>
  )
}

AudioRequest.propTypes = {
  protocol: PropTypes.object,
  onCloseModal: PropTypes.func,
  customerEmail: PropTypes.string,
  protocolDetails: PropTypes.object,
  requestAudioProtocol: PropTypes.func,
  getServiceRequestsCustomer: PropTypes.func,
  products: PropTypes.array
}

const mapStateToProps = ({ customer, repair, products }) => ({
  customerEmail: customer.data.email,
  documentNumber: customer.data.documentNumber,
  protocolDetails: repair.protocolDetails,
  products: products.plant.data
})

const enhance = compose(
  connect(mapStateToProps, { requestAudioProtocol, getServiceRequestsCustomer })
)

export default enhance(AudioRequest)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/AudioRequest/index.js